import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Lilate } from '../../../../../shared/src/lib/model/lilate.model';
import moment from 'moment';
import { Router } from '@angular/router';
import { CancelLilateComponent } from '../../../../../shared/src/lib/feature/cancel-lilate/cancel-lilate.component';
import { IdentityCheckComponent } from '../../../../../shared/src/lib/feature/identity-check/identity-check.component';
import { ExaminationService } from '../../../../../shared/src/lib/service/examination.service';
import { ExaminationSessionService } from '../../../../../shared/src/lib/service/examination-session.service';
import { Subject, takeUntil } from 'rxjs';
import { AuthenticationService } from '../../../../../shared/src/lib/service/authentification.service';
import { ExaminationVariantService } from '../../../../../shared/src/lib/service/examination-variant.service';
import { ExaminationVariants } from '../../../../../shared/src/lib/model/examinationVariants.model';

@Component({
    selector: 'app-teacher-lilate',
    templateUrl: './teacher-lilate.component.html',
    styleUrls: ['./teacher-lilate.component.scss']
})
export class TeacherLilateComponent implements OnInit, OnDestroy {
    @Input() lilate: Lilate;
    @Input() assessment: boolean;
    countdownStatus = 'in'
    duration;
    cancel: boolean = false;
    componentToLoad;
    componentName;
    modalParams;
    @Output() updateLilates = new EventEmitter();

    variant: ExaminationVariants = null;

    private _unsubscribeAll: Subject<any> = new Subject<any>();

    constructor(
        private router: Router,
        private examinationService: ExaminationService,
        private examinationSessionService: ExaminationSessionService,
        private authenticationService: AuthenticationService,
        private examinationVariantService: ExaminationVariantService
    ) { }

    ngOnInit() {
        this.initLilateDuration();
        if (moment(this.lilate.start).format('DD/MM/YYYY') === moment().format('DD/MM/YYYY') && this.lilate.last_examination_session) {
            if (this.lilate.last_examination_session.status === 'ongoing' || this.lilate.last_examination_session.status === 'pending') {
                this.getVariantByUrl(this.lilate.last_examination_session.variant)
            }
        }
    }

    ngOnDestroy(): void {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }

    initLilateDuration() {
        if (this.lilate) {
            const _sessionDiff = moment(this.lilate.end).diff(this.lilate.start);
            const sessionDuration = moment.duration(_sessionDiff);
            let halfTime = null;
            if (sessionDuration.asHours() > 1) {
                const calc = sessionDuration.asHours() / 2;
                halfTime = moment(this.lilate.start).add(calc.toString(), 'hours')
            } else {
                halfTime = moment(this.lilate.start).add('15', 'minutes')
            }
            // debugger
            const now = moment();
            let diff = moment(this.lilate.start).diff(now);
            this.duration = moment.duration(diff);
            if (this.duration.asHours() < 0) {
                if (moment(now).isAfter(moment(this.lilate.end))) {
                    this.countdownStatus = 'finish';
                    diff = moment(now).diff(this.lilate.end);
                    this.duration = moment.duration(diff);
                } else if (moment(now).isAfter(moment(halfTime))) {
                    this.countdownStatus = 'from';
                    diff = moment(now).diff(this.lilate.start);
                    this.duration = moment.duration(diff);

                } else {
                    this.countdownStatus = 'from';
                    diff = moment(now).diff(this.lilate.start);
                    this.duration = moment.duration(diff);
                }
            } else {
                this.countdownStatus = 'in';
            }
            this.cancel = (this.duration.asDays() > 1 && this.countdownStatus !== 'finish');
        }
    }

    linkIsValid() {
        if (this.lilate) {
            if (this.lilate.provider_link) {
                // le bouton skype est dispo à moins de 5 min avant le prochain cours ou pendant le cours (jusqu'à 30 min).
                if (this.duration && this.countdownStatus !== 'finish' && Math.floor(this.duration.asHours()) < 1 && this.duration.minutes() < 15 || this.countdownStatus === 'from') {
                    return true
                }
                return false
            }
        }
    }

    joinClass() {
        if (this.lilate.provider_link) {
            if (this.lilate.examination_version === '1') {
                window.open(this.lilate.provider_link, '_blank');
            } else if (this.lilate.examination_version === '2') {
                this.examinationService.openSession(this.authenticationService.currentUserSubject.value.user.email, this.lilate.id, localStorage.getItem('access_token'), '_blank');
            }
        }
    }


    openAssessment(): void {
        if (this.lilate.examination_version === '1') {
            this.router.navigateByUrl('lilate/assessment', { state: { data: { lilate: this.lilate } } });
        } else if (this.lilate.examination_version === '2') {
            this.examinationService.openSession(this.authenticationService.currentUserSubject.value.user.email, this.lilate.id, localStorage.getItem('access_token'), '_blank');
        }
    }

    showModalCancel() {
        this.componentToLoad = CancelLilateComponent;
        this.componentName = 'CancelLilateComponent';
        this.modalParams = { lilate: this.lilate, updateLilates: this.updateLilates }
    }

    showIdentity() {
        this.componentToLoad = IdentityCheckComponent;
        this.componentName = 'IdentityCheckComponent';
        this.modalParams = { lilate: this.lilate, updateLilates: this.updateLilates }
    }

    getVariantByUrl(url): void {
        this.examinationVariantService.getExaminationsVarianteByUrl(url).subscribe(
            variant => {
                this.variant = variant;
            }
        )
    }

    joinPreview() {
        if (this.variant) {
            this.examinationService.openExamPreview(this.authenticationService.currentUserSubject.value.user.email, this.variant.id, localStorage.getItem('access_token'));
        }
    }
}
